import { useLandingData } from '@/domains/landing-page/context/LandingDataContext';

const PROVIDER_COLORS = [
  'bg-orange-500',
  'bg-yellow-500',
  'bg-blue-600',
  'bg-cyan-500',
  'bg-green-600',
  'bg-red-600',
];

interface MobileMoneyModalProps {
  showMobileMoney: boolean;
  setShowMobileMoney: (show: boolean) => void;
}

export default function MobileMoneyModal({ showMobileMoney, setShowMobileMoney }: MobileMoneyModalProps) {
  const { payment_methods } = useLandingData();

  if (!showMobileMoney) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl max-w-2xl w-full">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-2xl font-bold text-gray-900">Solutions Mobile Money</h3>
            <button
              type="button"
              onClick={() => setShowMobileMoney(false)}
              className="text-gray-400 hover:text-gray-600"
            >
              <i className="ri-close-line text-2xl" />
            </button>
          </div>

          <p className="text-gray-600 mb-8">
            Payez vos livraisons directement depuis votre téléphone avec les solutions
            Mobile Money configurées sur ONAPILA.
          </p>

          {payment_methods.length === 0 ? (
            <p className="text-center text-gray-500 py-8">Aucun mode de paiement configuré pour le moment.</p>
          ) : (
            <div className="grid md:grid-cols-2 gap-4">
              {payment_methods.map((provider, index) => (
                <div key={provider.id} className="border rounded-xl p-4 hover:shadow-md transition-shadow">
                  <div className="flex items-center">
                    <div
                      className={`w-12 h-12 ${PROVIDER_COLORS[index % PROVIDER_COLORS.length]} rounded-lg flex items-center justify-center mr-4`}
                    >
                      <i className="ri-smartphone-line text-white text-xl" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">{provider.name}</h4>
                      {provider.description && (
                        <p className="text-sm text-gray-500 mt-1">{provider.description}</p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <button
            type="button"
            onClick={() => setShowMobileMoney(false)}
            className="mt-8 bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors w-full"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}
